import {
	PAGE_REACTIONS_SEGMENT_KEY,
	FEED_REACTIONS_SEGMENT_KEY,
	createPageSegmentLoadMetric,
} from '@confluence/browser-metrics';

export const PAGE_REACTIONS_METRIC = createPageSegmentLoadMetric({
	key: PAGE_REACTIONS_SEGMENT_KEY,
});

export const FEED_REACTIONS_METRIC = createPageSegmentLoadMetric({
	key: FEED_REACTIONS_SEGMENT_KEY,
});
